// @core/api/endpoints/document/acknowledge_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcknowledgeDocumentRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Acknowledge document
 * Records that the current user has read and acknowledged the document-aware entity.
 */
export async function AcknowledgeDocument(
  target_type: string,
  target_id: string,
  data: AcknowledgeDocumentRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/acknowledge`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
